'use client';

import { motion } from 'motion/react';
import { CornerTicks } from '@/components/marketing/site/hud';
import { useDocsScroll } from '@/components/docs/docs-scroll-context';
import { scrollToDocsSection } from '@/lib/docs-content';

export function DocsToc() {
  const { tocItems, activeSectionId, tocProgress, activeTocIndex } = useDocsScroll();

  if (tocItems.length === 0) return null;

  return (
    <aside aria-label="On this page" className="docs-toc hidden xl:block">
      <div className="notch-sm border-line bg-surface/20 relative border p-3">
        <CornerTicks className="border-accent/35" size={4} offset={3} />
        <p className="docs-toc__title">On this page</p>

        <div className="docs-toc-rail relative mt-3">
          <div aria-hidden className="docs-toc-rail__track">
            <div className="docs-toc-rail__line" />
            <motion.div
              className="docs-toc-rail__fill"
              animate={{ height: `${tocProgress * 100}%` }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>

          <ul className="docs-toc-rail__list space-y-1.5">
            {tocItems.map((item, index) => {
              const active = activeSectionId === item.id;
              const reached = activeTocIndex >= 0 && index <= activeTocIndex;

              return (
                <li key={item.id} className="docs-toc-rail__item relative">
                  <span
                    aria-hidden
                    className={`docs-toc-rail__dot ${reached ? 'docs-toc-rail__dot--reached' : ''} ${
                      active ? 'docs-toc-rail__dot--active' : ''
                    }`}
                  />
                  <a
                    href={`#${item.id}`}
                    onClick={(event) => {
                      event.preventDefault();
                      scrollToDocsSection(item.id);
                    }}
                    className={`docs-toc__link block py-0.5 pl-1 text-[0.8125rem] leading-snug transition-colors ${
                      active ? 'docs-toc__link--active' : reached ? 'docs-toc__link--reached' : ''
                    }`}
                    aria-current={active ? 'location' : undefined}
                  >
                    {item.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </aside>
  );
}
